import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getSemanticClassById = (shotclassId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_SEMANTIC_SEARCH_BY_ID(shotclassId)
  );
};

export default getSemanticClassById;
